import { createAPI } from '../../common'
import qs from 'qs'
/**
 * 对api请求进行二次封装，注意：因在打包后会对url进行加密处理在该方法内请勿直接操作url，如需操作可引用common中decryptUrl先进行解密再操作
 * @param url
 * @param action
 * @param config
 * @param vconfig
 * @returns {*}
 */
const requestCommonAPI = function (url, action, config = {}, vconfig) {
  config = {
    ...config,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      ...config.headers
    }
  }
  if (config.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
    config.data = qs.stringify(config.data)
  }
  if (config.MediaxMod) {
    config.headers.MediaxMod = config.MediaxMod
  }
  return createAPI(url, action, config, vconfig)
}
export default {
  // 采编选用----图片库、新华社
  postArticleSubmit: (config) =>
    requestCommonAPI('customEncryptApiName-1/0nfejby.dpoufou0bmmnfejb0bsujdmfTvcnju', 'post', config)
}
